// extracted by mini-css-extract-plugin
module.exports = {"baseContainer":"CollectionCard_baseContainer__13w-0","exploreButton":"CollectionCard_exploreButton__3eHNc","image":"CollectionCard_image__2Q4uN"};